import { convertParams } from 'src/utils/utils'
import axios from '../axios'
import { CHARTROUTES } from 'src/router/Api'
export const getChartDataUser = async (params) => {
	return await axios.get(CHARTROUTES.name, {
		params: convertParams(params),
	})
}
export const getCountUser = async (params) => {
	return await axios.get(CHARTROUTES.information, {
		params: convertParams(params),
	})
}

export const getChartDataUProvinceUser = async (params) => {
	return await axios.get(CHARTROUTES.provinceUser, {
		params: convertParams(params),
	})
}
export const getChartDataUCountryUser = async (params) => {
	return await axios.get(CHARTROUTES.countryUser, {
		params: convertParams(params),
	})
}
export const getUsersByCountry = async (params) => {
	return await axios.get(CHARTROUTES.usersByCountry, {
		params: convertParams(params),
	})
}
export const getUsersByProvince = async (params) => {
	return await axios.get(CHARTROUTES.usersByProvince, {
		params: convertParams(params),
        }
    )
}

export const getVersionStats = async (params) => {
	return await axios.get(CHARTROUTES.versionStats, {
		params: params,
	})
}
export const getCommunityStats = async (params) => {
	return await axios.get(CHARTROUTES.communityStats, {
		params: params,
	})
}
export const getChartDataActiveUser = async (params) => {
	// console.log(params);
	return await axios.get(CHARTROUTES.onlineUsersCount, {
		params: params,
	})
}
export const getNewUserMetics = async (params) => {
	return await axios.get(CHARTROUTES.newUserMetrics, {
		params: params,
	})
}
export const getActiveUserMetics = async (params) => {
	return await axios.get(CHARTROUTES.activeUserMetrics, {
		params: params,
	})
}
export const getRetentionMetrics = async (params) => {
	return await axios.get(CHARTROUTES.retentionMetrics, {
		params: params,
	})
}
export const getSectionAnalytics = async (params) => {
	return await axios.get(CHARTROUTES.sectionAnalytics, {
		params: params,
	})
}

export const getSectionEngagement = async (params) => {
	return await axios.get(CHARTROUTES.sectionEngagement, {
		params: params,
	})
}

export const getSectionFeature = async (params) => {
	return await axios.get(CHARTROUTES.sectionFeatureUsage, {
		params: params,
	})
}
